import React from 'react'
import { translate } from 'react-i18next'

import Icon from '../../Global/Icon'

export default translate('common')(({ closeMap, slug, t, trip: {acf: {img_maps, steps}} }) => (
  <div className="trip__map">
    <div className="trip__map-button">
      <button className="button button--outline button--icon" type="button" onClick={() => closeMap()}>
        <Icon className="icon" icon="close" />
      </button>
    </div>
    <div className="trip__map-inner">
      <img className="map__image" src={img_maps.url} alt={img_maps.alt} />
      <div className="container">
        <div className="trip__map-steps-title">{ t('trip-map.title') }</div>
        <div className="trip__map-steps-list">
          <ul className="list">
            {steps.map((step, index) => (
              <li className="list__item" key={index}>
                <span className="list__item-index">{index + 1}</span>
                <span className="list__item-name">{step.step_name}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  </div>
))



// WEBPACK FOOTER //
// ./src/components/Trip/TripMap/TripMap.js